export default __webpack_public_path__ + "static/media/gel-buffer-3.21875acf.svg";